import React from "react";

const ProgressSection = () => {
  const progressData = [
    { img: "/assets/img/Scarless.webp", title: "No.1", subtitle: "in scarless & \n laparoscopic Surgeries", delay: 100 },
    { img: "/assets/img/Emergency.webp", title: "Level 1", subtitle: "Emergency & Trauma \n Care", delay: 200 },
    { img: "/assets/img/Lives.webp", title: "1 Million", subtitle: "Lives Saved", delay: 300 },
    { img: "/assets/img/Multispecialities.webp", title: "25+", subtitle: "Multispecialties", delay: 400 },
  ];

  return (
    <section className="progress-section py-5">
      <div className="container">
        <div className="row">
          {progressData.map((item, index) => (
            <div className="col-lg-3" key={index}>
              <div
                className="progress-card"
                data-sal="slide-up"
                data-sal-duration="1000"
                data-sal-delay={item.delay}
              >
                <div className="progress-img-wrapper">
                  <img src={item.img} alt={`progress-icon-${index + 1}`} />
                </div>
                <h2 className="progress-title">{item.title}</h2>
                <p className="progress-subtitle">{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgressSection;